var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('Sidebar'),_c('div',{staticClass:"content"},[_c('LoggedInHeader'),_c('LoggedInHeaderMobile'),_c('div',{staticClass:"mp-logged-in-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }